/* tslint:disable */
/* eslint-disable */
/**
 * Public Track API
 * Public Track APIs provide customers access to their SPiDRs, Security Focuses and SPiDR Blueprints
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BlueprintFromJSON, BlueprintToJSON, } from './Blueprint';
import { SecurityFocusStateFromJSON, SecurityFocusStateToJSON, } from './SecurityFocusState';
import { SpidrFromJSON, SpidrToJSON, } from './Spidr';
/**
 * Check if a given object implements the SecurityFocusFull interface.
 */
export function instanceOfSecurityFocusFull(value) {
    let isInstance = true;
    isInstance = isInstance && "blueprints" in value;
    isInstance = isInstance && "spidrs" in value;
    isInstance = isInstance && "startedAt" in value;
    isInstance = isInstance && "completedAt" in value;
    isInstance = isInstance && "outcomes" in value;
    isInstance = isInstance && "goals" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "detour" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "dateAdded" in value;
    isInstance = isInstance && "spidrCount" in value;
    return isInstance;
}
export function SecurityFocusFullFromJSON(json) {
    return SecurityFocusFullFromJSONTyped(json, false);
}
export function SecurityFocusFullFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'blueprints': (json['blueprints'].map(BlueprintFromJSON)),
        'spidrs': (json['spidrs'].map(SpidrFromJSON)),
        'startedAt': (json['startedAt'] === null ? null : new Date(json['startedAt'])),
        'completedAt': (json['completedAt'] === null ? null : new Date(json['completedAt'])),
        'outcomes': json['outcomes'],
        'goals': json['goals'],
        'id': json['id'],
        'name': json['name'],
        'detour': json['detour'],
        'state': SecurityFocusStateFromJSON(json['state']),
        'dateAdded': (new Date(json['dateAdded'])),
        'spidrCount': json['spidrCount'],
    };
}
export function SecurityFocusFullToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'blueprints': (value.blueprints.map(BlueprintToJSON)),
        'spidrs': (value.spidrs.map(SpidrToJSON)),
        'startedAt': (value.startedAt === null ? null : value.startedAt.toISOString()),
        'completedAt': (value.completedAt === null ? null : value.completedAt.toISOString()),
        'outcomes': value.outcomes,
        'goals': value.goals,
        'id': value.id,
        'name': value.name,
        'detour': value.detour,
        'state': SecurityFocusStateToJSON(value.state),
        'dateAdded': (value.dateAdded.toISOString()),
        'spidrCount': value.spidrCount,
    };
}
